<div class="elementor-field-type-select-multiple elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
    <label for="form-field-gender" class="elementor-field-label elementor-screen-only">
        {{placeholder}}
    </label>
    <select id="form-field-gender" class="elementor-field elementor-size-sm  elementor-field-type-select-multiple" v-model="selectedValue" @change="onSelectValueChange">
        <option value="0" disabled selected>{{placeholder}}</option>
        <option v-for="selectOption in selectOptions" :value="selectOption.id">{{selectOption.text}}</option>
    </select>
</div>